import React, { useReducer } from "react";

import { gameContext } from "../contexts/game";
import { gameContextReducer } from "../contexts/game/reducers/game-context-reducer";

export const withGameContextProvider = <P extends Record<string, unknown>>(
    Component: React.ComponentType<P>,
) => {
    const { Provider } = gameContext;

    return (props: P) => {
        const [state, dispatch] = useReducer(gameContextReducer, {
            settings: {
                game: {},
            },
            video: {},
        });

        return (
            <Provider value={{ state, dispatch }}>
                <Component {...props} />
            </Provider>
        );
    };
};
